module.exports = __webpack_public_path__ + "static/media/apple-appstore-badge.e794e022.png";